export enum EmploymentRelationshipType {
Salaried,
DailySalaried,
HourlySalaried,
SelfEmployment,
ReceiptOfExpense,
Management,
Internship,
Trainee,
}
